import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  categoryData: [],
  totalCategory:0,
  isOpenModal: false,
  isStatusOpenModal:false,
}

export const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setCategoryData(state, { payload }) {
      state.categoryData = payload.result
      state.totalCategory = payload.count
    },
    updateCategoryData(state, { payload }) {
      const objIndex = state.categoryData.findIndex((obj) => obj.id === payload.id);
      if(objIndex>=0){
        state.categoryData[objIndex]=payload
      }
    },
    pushCategoryData (state,{payload}){
      state.categoryData.push(payload)
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    }
  }
})

export const { setCategoryData, updateCategoryData,pushCategoryData, isOpenModal, 
  ModalToggle,setFaqsSpecializationData,isOpenStatusModal,statusToggle } = categorySlice.actions;

export default categorySlice.reducer;

export function getCategory(limit, offset, status, keyword) {
  return async function getCategoryThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getCategory(limit, offset, status, keyword).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setCategoryData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addCategory(payload) {
  return async function addCategoryThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addCategory(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushCategoryData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateCategory(id,name) {
  return async function updateCategoryThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateCategory(id,name).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateCategoryData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function statusUpdateCategory(payload) {
  return async function statusUpdateCategoryThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdateCategory(payload.id,payload.status).then(
        (response) => {
          dispatch(statusToggle())
          dispatch(updateCategoryData(response.data))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

